import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import FinanceServices from "../based/services/FinanceServices";
import Common from "../based/Common";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

function FinancePartnerModal({ show, onClose, walletId, onPostpone, onManual }) {
    const [model, setModel] = useState({});

    useEffect(() => {
        if (walletId) {
            getData(walletId);
        }
    }, [walletId]);

    const getData = async (id) => {
        const [err, data] = await FinanceServices.GetTicketPaymentHistoryModelById(id);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
    };

    return (
        <CommonModal
            size="md"
            title="Chi tiết"
            show={show}
            onClose={onClose}
            hideOnClose
            customButton={
                <div className="lst-button">
                    <button
                        className="btn btn-danger mx-2"
                        onClick={(e) => {
                            onClose();
                        }}
                    >
                        Đóng
                    </button>
                    {model.status != 1 && (
                        <button
                            className="btn btn-purple mx-2"
                            onClick={(e) => {
                                e.preventDefault();
                                onPostpone();
                            }}
                        >
                            Tạm hoãn chuyển
                        </button>
                    )}
                    <button
                        className="btn btn-custom mx-2"
                        onClick={(e) => {
                            e.preventDefault();
                            onManual();
                        }}
                    >
                        Chuyển thủ công
                    </button>
                </div>
            }
        >
            {model && model.walletId > 0 ? (
                <Wrapper>
                    <div className="payment-status">
                        <h6>{model.statusName}</h6>
                        <div className="form-box">
                            <div className="form-group">
                                <label htmlFor="">Mã giao dịch</label>
                                <span>
                                    {model.walletId} <i className="fa fa-copy"></i>
                                </span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Ngày yêu cầu</label>
                                <span>{Common.formatDate(new Date(model.createdDate))}</span>
                            </div>
                        </div>
                    </div>
                    <div className="payment-detail">
                        <div className="detail-header">
                            <div className="form-group">
                                <label htmlFor="">Số tiền rút</label>
                                <span>{Common.formatCurrency(Math.abs(model.amount))}</span>
                            </div>
                        </div>
                        <div className="detail-body">
                            <h6>Ví {model.walletTypeName}</h6>
                            <div className="form-group">
                                <label htmlFor="">Số dư</label>
                                <span>{Common.formatCurrency(model.walletAmount)}</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Có thể rút</label>
                                <span>{Common.formatCurrency(model.walletAmount - model.walletAmountOnHold)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="payment-bank">
                        <div className="form-group">
                            <label htmlFor="">Partner</label>
                            <span>{model.displayName}</span>
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Ngân hàng</label>
                            <span>{model.bankName}</span>
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Tên chủ tài khoản</label>
                            <span>{model.bankAccountName}</span>
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Số tài khoản</label>
                            <span>{model.bankAccountNumber}</span>
                        </div>
                    </div>
                    {model.transferImage && (
                        <div className="form-group">
                            <label htmlFor="">Ảnh chuyển khoản</label>
                            <img src={model.transferImage} alt="" />
                        </div>
                    )}
                    {model.transferReferenceCode && (
                        <div className="form-group">
                            <label htmlFor="">Mã giao dịch ngân hàng</label>
                            <span
                                className="cursor-pointer"
                                onClick={(e) => {
                                    navigator.clipboard.writeText(model.transferReferenceCode);
                                    Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Đã sao chép mã giao dịch");
                                }}
                            >
                                {model.transferReferenceCode}
                                <i className="fa fa-copy"></i>
                            </span>
                        </div>
                    )}
                </Wrapper>
            ) : (
                <Wrapper>
                    <div className="no-data">Không có dữ liệu</div>
                </Wrapper>
            )}
        </CommonModal>
    );
}

export default FinancePartnerModal;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    .payment-bank {
        width: 100%;
    }

    .payment-status {
        width: 50%;
        border: 1px solid #d9d9d9;
        background: #ffe3bf;
        padding: 10px;
    }

    .payment-status h6 {
        color: #ff9027;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0 0 10px 0;
    }

    .form-group span {
        display: flex;
        align-items: center;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
        flex: 1;
    }

    .form-group {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
    }

    .form-group label {
        color: #a0a0a0;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0;
        width: 35%;
    }

    .payment-detail {
        width: calc(50% - 20px);
        margin-left: 20px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .detail-header {
        padding: 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .detail-header .form-group {
        margin: 0;
    }

    .detail-body {
        padding: 10px;
    }

    .detail-body h6 {
        margin: 0 0 10px 0;
    }

    .payment-bank {
        border: 1px solid #d9d9d9;
        background: #fff;
        margin: 12px 0;
        padding: 10px;
    }

    .payment-bank label {
        width: 35%;
    }

    .payment-bank span {
        flex: 1;
    }

    .form-group img {
        width: 72px;
        height: 72px;
        object-fit: contain;
        margin-left: 12px;
        flex: 1;
    }

    .lst-button .btn {
        margin: 0 6px !important;
    }
`;
